
const Filtros = ({
  filtroTipo,
  setFiltroTipo,
  filtroClasificacion,
  setFiltroClasificacion,
  filtroColor,
  setFiltroColor
}) => {
  return (
    <>
      <div className="opciones">
        <div>Filtrar por: </div>
        {/* <form> */}
        <select
          value={filtroTipo}
          onChange={(e) => setFiltroTipo(e.target.value)}
        >
          <option value="">Tipo</option>
          <option value="gasto">Gasto</option>
          <option value="ingreso">Ingreso</option>
        </select>

        <select
          value={filtroClasificacion}
          onChange={(e) => setFiltroClasificacion(e.target.value)}
        >
          <option value="">Clasificación</option>
          <option value="Fijo">Fijo</option>
          <option value="Variable">Variable</option>
        </select>

        <select
          value={filtroColor}
          onChange={(e) => setFiltroColor(e.target.value)}
        >
          <option value="">Color</option>
          <option className="jazzberry-jam" value="#AD1457">Jazzberri Jam</option>
          <option className="fire-engine-red" value="#C62828">Fire Engine Red</option>
          <option className="vermilion" value="#D84315">Vermilion</option>
          <option className="spanish-orange" value="#EF6C00">Spanish Orange</option>
          <option className="bright-yellow" value="#F9A825">Bright Yellow</option>
          <option className="japanese-laurel" value="#2E7D32">Japanese Laurel</option>
          <option className="maximum-green" value="#558B2F">Maximum Green</option>
          <option className="yale-blue" value="#0D47A1">Yale Blue</option>
          <option className="ocean-boat-blue" value="#0277BD">Ocean Boat Blue</option>
          <option className="tiffany-blue" value="#00ACC1">Tiffany Blue</option>
          <option className="blue-pigment" value="#4527A0">Blue Pigment</option>
          <option className="chinese-purple" value="#6A1B9A">Chinese Purple</option>
        </select>

        {/* </form> */}
      </div>
    </>
  )
}

export default Filtros